import { useQuery } from "@tanstack/react-query";
import {
  ProcurementControllerGetProcurementSuppliers200Response,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_PROCUREMENT } from "../domain";

import { procurementApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";


export const ACTION_GET_PROCUREMENT_SUPPLIERS = "GET_PROCUREMENT_SUPPLIERS";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Viewer, UserRole.Auditor];

type UseGetProcurementSuppliersParams = {
  search?: string;
  orderBy?: string;
  orderDirection?: string;
  pageNumber?: number;
  pageSize?: number;
};

const getProcurementSuppliers = async ({
  search,
  orderBy,
  orderDirection,
  pageNumber,
  pageSize,
}: UseGetProcurementSuppliersParams): Promise<ProcurementControllerGetProcurementSuppliers200Response> => {
  const response = await procurementApi.procurementControllerGetProcurementSuppliers(
    search,
    orderBy,
    orderDirection,
    pageNumber,
    pageSize,
  );

  return response.data;
};

export const useGetProcurementSuppliers = (
  user: UserProfileDto | null,
  search?: string,
  orderBy?: string,
  orderDirection?: string,
  pageNumber = 1,
  pageSize = 10,
): {
  procurementSuppliers:
    | ProcurementControllerGetProcurementSuppliers200Response
    | undefined;
  procurementSuppliersEnabled: boolean;
  isPendingGetProcurementSuppliers: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isPending } = useQuery({
    queryKey: [
      DOMAIN_PROCUREMENT,
      ACTION_GET_PROCUREMENT_SUPPLIERS,
      search,
      orderBy,
      orderDirection,
      pageNumber,
      pageSize,
    ],
    queryFn: () =>
      getProcurementSuppliers({
        search,
        orderBy,
        orderDirection,
        pageNumber,
        pageSize,
      }),
    select: (response) => response,
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    procurementSuppliers: data,
    procurementSuppliersEnabled: enabled,
    isPendingGetProcurementSuppliers: isPending,
  };
};
